function state() {
  return {
    provinces: [],
  };
}

export default state;
